import React from "react";
import HeaderText from "../../../views/components/HeaderText";
import GenericInformation from "../../../views/components/GenericInformationSection";
import { formatPriceWithCurrencySymbol } from "../../../shared/utility";
import ParagraphText from "../../../views/components/ParagraphText";
import COLOURS from "../../../views/theme/base/colours";

const VendorVehiclePricingSummaryModal = ({
  className,
  pricingSummaryData,
  headerText,
  vehicleSummaryColumns,
  percentageSummaryColumns,
  monetarySummaryColumns,
  finalPriceSummaryColumns,
  DETAILS_TEXT,
  helpText,
}) => {  
  const getFormattedValue = (key, value) => {
    if (value === null) return "-";

    const percentageFormat = (val) => (
      <span className="primaryText">{val || "0"}%</span>
    );

    const formattedPrice = (val, isGreen = false) => (
      <span className={isGreen ? "greenText" : "primaryText"}>
        {formatPriceWithCurrencySymbol(val, true)}
      </span>
    );

    const totalPercentage =
        pricingSummaryData.percentageDirection === "I"
          ? pricingSummaryData.percentageSummaryData.basePercentage + pricingSummaryData.percentageSummaryData.adjustment
          : pricingSummaryData.percentageSummaryData.basePercentage - pricingSummaryData.percentageSummaryData.adjustment;      

    switch (key) {
      case "baseValuation":
        return (
          <>
            {formatPriceWithCurrencySymbol(value, true) || "-"} ({pricingSummaryData.condition})
          </>
        );
      case "basePercentage":

        return (
          <span className="primaryText">
            {percentageFormat(pricingSummaryData.percentageSummaryData.basePercentage)}&nbsp;
            {pricingSummaryData.percentageSummaryData.adjustment !== 0.0000 && (
            <>
              {pricingSummaryData.percentageDirection === "I" ? " +" : " -"}&nbsp;
              {percentageFormat(pricingSummaryData.percentageSummaryData.adjustment)}&nbsp;=&nbsp;
              {percentageFormat(totalPercentage)}
            </>
            )}
          </span>
        );
        case "calculatedValue":
          return (
            <span className="primaryText">
              {percentageFormat(totalPercentage)}&nbsp;of&nbsp;{formattedPrice(pricingSummaryData.percentageSummaryData.baseValuation)}&nbsp;=&nbsp;{formattedPrice(value)}
            </span>
          );
        case "additionalAdjustment":
          return value !== 0 ? (
            <span className="primaryText">
              {pricingSummaryData.percentageDirection === "I" ? "+ " : "- "}
              {formattedPrice(value)}
            </span>
          ) : (
            "-"
          );
        case "effectOnPrice":
          const percentageDirection = pricingSummaryData.percentageDirection;
          const additionalAdjustment = pricingSummaryData.monetarySummaryData.additionalAdjustment;
          return pricingSummaryData.monetarySummaryData.additionalAdjustment !== 0 ? (
            <span className="primaryText">
              {formattedPrice(pricingSummaryData.monetarySummaryData.calculatedValue)}&nbsp;
              {percentageDirection === "I" ? "+ " : "- "} &nbsp;
              {formattedPrice(additionalAdjustment)}&nbsp;=&nbsp;
              {formattedPrice(value)}
            </span>
          ) : (
            "-"
          );
      case "finalPrice":
        return formattedPrice(value, true);
      default:
        return typeof value === "number" ? formatPriceWithCurrencySymbol(value) : value;
    }
  };

  return (
    <div className={className}>
      <HeaderText>{headerText}</HeaderText>
      <ParagraphText primary>
        {DETAILS_TEXT} {pricingSummaryData.requestType}:
      </ParagraphText>
      <hr />
      <GenericInformation
        className={className}
        informationData={pricingSummaryData.vehicleSummaryData}
        columns={vehicleSummaryColumns}
        getFormattedValue={getFormattedValue}
      />
      <hr />
      <ParagraphText>{helpText.BASE_PERCENTAGE}</ParagraphText>
      <GenericInformation
        className={className}
        informationData={pricingSummaryData.percentageSummaryData}
        columns={percentageSummaryColumns}
        getFormattedValue={getFormattedValue}
      />
      <hr />
      <GenericInformation
        className={className}
        informationData={pricingSummaryData.monetarySummaryData}
        columns={monetarySummaryColumns}
        getFormattedValue={getFormattedValue}
      />
      <hr />
      <ParagraphText>{helpText.FINAL_PRICE}</ParagraphText>
      <GenericInformation
        className={className}
        informationData={pricingSummaryData.finalPriceSummaryData}
        columns={finalPriceSummaryColumns}
        getFormattedValue={getFormattedValue}
      />
    </div>
  );
};

export default VendorVehiclePricingSummaryModal;
 